import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Shared event bus between dynamically loaded exercise-type editor components and ContentEntityComponent.
 *
 * Background: ContentEntityComponent uses NgComponentOutlet to dynamically render type-specific
 * editor components (e.g. FreeInputTextEditorComponent). NgComponentOutlet supports input bindings
 * but does NOT support @Output() bindings, so a dynamically loaded editor cannot emit events
 * directly to its parent.
 *
 * Solution: Each editor component injects this service and calls notifyPartChanged() whenever
 * the user modifies data. ContentEntityComponent subscribes to partChanged$ and forwards the
 * update to the player preview via postMessage.
 *
 * When adding a new exercise-type editor:
 * 1. Inject ContentEditorService in your editor component.
 * 2. Call this.contentEditorService.notifyPartChanged() wherever you would normally emit an @Output().
 * 3. No changes needed in ContentEntityComponent – it already listens to partChanged$.
 */
@Injectable({ providedIn: 'root' })
export class ContentEditorService {
  private readonly partChangedSubject = new Subject<void>();
  public readonly partChanged$ = this.partChangedSubject.asObservable();

  public notifyPartChanged(): void {
    this.partChangedSubject.next();
  }
}
